<div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-plus-circle text-success"></i>
      Ajouter un apport supplémentaire
    </h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <form [formGroup]="apportForm" (ngSubmit)="confirmerApport()">
    <div class="modal-body">
      
      <!-- INFORMATIONS ACTUELLES DU DOSSIER -->
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="alert alert-info">
            <h6><i class="fas fa-info-circle"></i> État actuel du dossier</h6>
            <div class="row">
              <div class="col-md-3">
                <small class="text-muted">Échéances payées :</small><br>
                <strong class="text-success">{{ nombreEcheancesPayees }}</strong>
              </div>
              <div class="col-md-3">
                <small class="text-muted">Échéances impayées :</small><br>
                <strong class="text-warning">{{ echeancesImpayees.length }}</strong>
              </div>
              <div class="col-md-6">
                <small class="text-muted">Capital restant actuel :</small><br>
                <strong class="text-primary">{{ capitalRestantActuel | number }} F CFA</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- FORMULAIRE D'APPORT -->
      <div class="row mb-3">
        <div class="col-md-12">
          <h6 class="text-secondary mb-3">
            <i class="fas fa-money-bill-wave"></i> Détails de l'apport supplémentaire
          </h6>
        </div>
      </div>
  
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="montantApport">
              Montant de l'apport <span class="text-danger">*</span>
            </label>
            <input 
              type="number" 
              class="form-control" 
              id="montantApport"
              formControlName="montantApport"
              placeholder="Montant en F CFA"
              [ngClass]="{
                'is-invalid': submit && f.montantApport.errors,
                'is-valid': submit && f.montantApport.valid && montantApportValide
              }"
            >
            <div class="invalid-feedback" *ngIf="submit && f.montantApport.errors">
              <div *ngIf="f.montantApport.errors.required">{{ required.novide }}</div>
              <div *ngIf="f.montantApport.errors.min">Le montant minimum est de 1 000 F CFA</div>
            </div>
            <div class="invalid-feedback" 
                 *ngIf="submit && f.montantApport.valid && !montantApportValide"
                 style="display: block;">
              Le montant doit être inférieur au capital restant ({{ capitalRestantActuel | number }} F CFA)
            </div>
          </div>
        </div>
        
        <div class="col-md-6">
          <div class="form-group">
            <label for="choixRecalcul">
              Choix de recalcul <span class="text-danger">*</span>
            </label>
            <select 
              class="form-control" 
              id="choixRecalcul"
              formControlName="choixRecalcul"
              [ngClass]="{
                'is-invalid': submit && f.choixRecalcul.errors,
                'is-valid': submit && f.choixRecalcul.valid
              }"
            >
              <option *ngFor="let option of choixRecalculOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="submit && f.choixRecalcul.errors">
              <div *ngIf="f.choixRecalcul.errors.required">{{ required.novide }}</div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- NOUVELLE DURÉE (visible seulement si REDUIRE_DUREE est sélectionné) -->
      <div class="row" *ngIf="f.choixRecalcul.value === 'REDUIRE_DUREE'">
        <div class="col-md-6">
          <div class="form-group">
            <label for="nouvelleDuree">
              Nouvelle durée (en mois) <span class="text-danger">*</span>
              <small class="text-muted">(entre 1 et {{ echeancesImpayees.length }} mois)</small>
            </label>
            <input 
              type="number" 
              class="form-control" 
              id="nouvelleDuree"
              formControlName="nouvelleDuree"
              placeholder="Nombre de mois"
              [min]="1"
              [max]="echeancesImpayees.length"
              [ngClass]="{
                'is-invalid': submit && f.nouvelleDuree.errors,
                'is-valid': submit && f.nouvelleDuree.valid
              }"
            >
            <div class="invalid-feedback" *ngIf="submit && f.nouvelleDuree.errors">
              <div *ngIf="f.nouvelleDuree.errors.required">{{ required.novide }}</div>
              <div *ngIf="f.nouvelleDuree.errors.min">La durée doit être d'au moins 1 mois</div>
              <div *ngIf="f.nouvelleDuree.errors.max">La durée ne peut pas dépasser {{ echeancesImpayees.length }} mois</div>
            </div>
            <small class="form-text text-muted">
              Nombre de mois sur lequel les mensualités seront recalculées
            </small>
          </div>
        </div>
      </div>
  
      <!-- APERÇU RAPIDE -->
      <div class="row" *ngIf="montantApportValide && f.montantApport.value > 0">
        <div class="col-md-12">
          <div class="alert alert-light border">
            <h6><i class="fas fa-calculator"></i> Aperçu rapide</h6>
            <div class="row">
              <div class="col-md-6">
                <small class="text-muted">Capital restant après apport :</small><br>
                <strong class="text-success">{{ capitalRestantApresApport | number }} F CFA</strong>
              </div>
              <div class="col-md-6">
                <small class="text-muted">Réduction du capital :</small><br>
                <strong class="text-info">{{ f.montantApport.value | number }} F CFA</strong>
              </div>
            </div>
            <small class="text-muted">
              <i class="fas fa-info-circle"></i>
              Cliquez sur "Simuler" pour voir l'impact détaillé sur vos échéances.
            </small>
          </div>
        </div>
      </div>
  
      <!-- COMMENTAIRE OPTIONNEL -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="commentaire">Commentaire (optionnel)</label>
            <textarea 
              class="form-control" 
              id="commentaire"
              formControlName="commentaire"
              rows="2"
              placeholder="Ajoutez un commentaire sur cet apport..."
            ></textarea>
          </div>
        </div>
      </div>
  
      <!-- RÉSULTATS DE SIMULATION -->
      <div class="row" *ngIf="simulationResult">
        <div class="col-md-12">
          <div class="alert alert-success">
            <h6><i class="fas fa-chart-line"></i> Résultats de la simulation</h6>
            <hr>
            
            <div class="row mb-3">
              <div class="col-md-6">
                <h6 class="text-primary">Situation actuelle</h6>
                <p><strong>Capital restant :</strong> {{ simulationResult.capitalRestantAvant | number }} F CFA</p>
                <p><strong>Mensualité actuelle :</strong> {{ simulationResult.ancienneMensualite | number }} F CFA</p>
                <p><strong>Durée restante :</strong> {{ simulationResult.ancienneDuree }} mois</p>
              </div>
              
              <div class="col-md-6">
                <h6 class="text-success">Nouvelle situation</h6>
                <p><strong>Nouveau capital :</strong> {{ simulationResult.capitalRestantApres | number }} F CFA</p>
                <p><strong>Nouvelle mensualité :</strong> 
                  <span [ngClass]="{
                    'text-success': simulationResult.nouvelleMensualite < simulationResult.ancienneMensualite,
                    'text-primary': simulationResult.nouvelleMensualite >= simulationResult.ancienneMensualite
                  }">
                    {{ simulationResult.nouvelleMensualite | number }} F CFA
                  </span>
                </p>
                <p><strong>Nouvelle durée :</strong> 
                  <span [ngClass]="{
                    'text-success': simulationResult.nouvelleDuree < simulationResult.ancienneDuree,
                    'text-primary': simulationResult.nouvelleDuree >= simulationResult.ancienneDuree
                  }">
                    {{ simulationResult.nouvelleDuree }} mois
                  </span>
                </p>
              </div>
            </div>
  
            <!-- ÉCONOMIE RÉALISÉE -->
            <div class="row" *ngIf="simulationResult.economieTotal">
              <div class="col-md-12">
                <div class="bg-success text-white p-3 rounded">
                  <h6><i class="fas fa-piggy-bank"></i> Économie totale prévue</h6>
                  <h5 class="mb-0">{{ simulationResult.economieTotal | number }} F CFA</h5>
                </div>
              </div>
            </div>
  
            <!-- DIFFÉRENCES MISES EN ÉVIDENCE -->
            <div class="row mt-3">
              <div class="col-md-6" *ngIf="f.choixRecalcul.value === 'REDUIRE_MENSUALITE'">
                <div class="bg-info text-white p-2 rounded text-center">
                  <small>Réduction mensuelle</small><br>
                  <strong>- {{ (simulationResult.ancienneMensualite - simulationResult.nouvelleMensualite) | number }} F CFA</strong>
                </div>
              </div>
              
              <div class="col-md-6" *ngIf="f.choixRecalcul.value === 'REDUIRE_DUREE'">
                <div class="bg-warning text-white p-2 rounded text-center">
                  <small>Réduction de durée</small><br>
                  <strong>- {{ simulationResult.ancienneDuree - simulationResult.nouvelleDuree }} mois</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- MESSAGES D'ÉTAT -->
      <div class="row" *ngIf="isSimulating">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <i class="fas fa-spinner fa-spin"></i>
            Simulation en cours, veuillez patienter...
          </div>
        </div>
      </div>
  
    </div>
  
    <!-- FOOTER MODAL -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onClose()">
        <i class="fas fa-times"></i> Fermer
      </button>
      
      <button 
        type="button" 
        class="btn btn-info" 
        (click)="simulerApport()"
        [disabled]="apportForm.invalid || !montantApportValide || isSimulating"
      >
        <i class="fas fa-calculator"></i>
        <span *ngIf="!isSimulating">Simuler l'impact</span>
        <span *ngIf="isSimulating">Simulation...</span>
      </button>
      
      <button 
        type="button" 
        class="btn btn-warning" 
        (click)="reinitialiserSimulation()"
        *ngIf="simulationResult && !isSubmitting"
      >
        <i class="fas fa-redo"></i> Nouvelle simulation
      </button>
      
      <button 
        type="submit" 
        class="btn btn-success" 
        [disabled]="!simulationResult || isSubmitting"
        *ngIf="simulationResult"
      >
        <i class="fas fa-check"></i>
        <span *ngIf="!isSubmitting">Confirmer l'apport</span>
        <span *ngIf="isSubmitting">Enregistrement...</span>
      </button>
    </div>
  </form>